import { FC } from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box } from '@qwealth/qcore';

import ComplianceHeaderButton from './ComplianceHeaderButton';
import { useAppSelector } from 'data/store';
import { selectClientComplianceReview } from 'data/selectors/compliance';
import { complianceRoute } from 'data/refData/compliance';

const ComplianceHeader: FC = (): JSX.Element => {
  const location = useLocation();
  const isReviewsSection = location.pathname === `/${complianceRoute.path}`;
  const navigate = useNavigate();
  const selectedContactName: string | undefined = useAppSelector(selectClientComplianceReview)?.name ?? 'Client';

  return (
    <Box display="flex" flexDirection="column" marginBottom="large" boxShadow="layout">
      <Box backgroundColor="primary" color="white" padding="default" fontSize="appTitle" fontWeight="bold" borderRadius="default">
        {complianceRoute.label}
      </Box>
      <Box backgroundColor="white" padding="default" color="gray.1" display="flex" flexDirection="row" alignItems="center" gap="small">
        <ComplianceHeaderButton
          name={'New Account Reviews'}
          icon={'Folder'}
          isCurrentSection={isReviewsSection}
          onClick={() => navigate(`/${complianceRoute.path}`)}
        />
        {selectedContactName && !isReviewsSection && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <BsChevronRight />
            <ComplianceHeaderButton name={selectedContactName} icon={'Person'} isCurrentSection={true} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ComplianceHeader;
